<template>
  <div id="app">
    <Home :user="user" :dashId="dashId" :entryType="entryType" :applicationContext="applicationContext"></Home>
  </div>
</template>

<script>


import Home from "./components/Home";


export default {
  name: 'App',
  components: {
    Home
  },

  data() {
    return {
      user: null,
      dashId : null,
      entryType : null,
      applicationContext : null
    }
  },

  created: function() {
    let userElement=document.getElementById('userdetails')
    let innerDashboardId = document.getElementById('dashboard_id')
    let innerEntryType = document.getElementById('entry_type')
    let innerApplicationContext = document.getElementById('application_context')

    if (innerDashboardId) {
      let dashboardId = innerDashboardId.innerHTML
      if (dashboardId && dashboardId.trim() != "") {
        this.dashId= dashboardId
      }
    } else {
      this.dashId= null
    }


    if (innerEntryType) {
      let entryTypetmp = innerEntryType.innerHTML
      console.log("get entry type from gallery", entryTypetmp)
      if (entryTypetmp && entryTypetmp.trim() != "") {
        this.entryType= entryTypetmp
        console.log("coming from gallery")
      }
    } else {
      this.entryType= null
    }


    if (userElement) {
      let userdetails = userElement.innerHTML
      if (userdetails && userdetails.trim() != "") {
        this.user = userdetails
      }
    } else {
      this.user= null
    }

    if (innerApplicationContext) {
      this.applicationContext = innerApplicationContext.innerHTML;
    } else {
      this.applicationContext = '/'
    }
    console.debug("Application context: "+this.applicationContext)
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 1%;
  background: #edf3f7 !important;
  display: block;
}

#app .widget-legend {
  width: 100%;
  text-align: center;
}



</style>
